import { format, parse } from 'date-fns'

const FORMATS = {
   filterDateAPI: 'd MMM yyyy',
   filterDateUI: 'd MMM yyyy',
   excelExport: 'd MMM yyyy',
}

const renderDateOrNothing = (date: any) => {
   if (!date.value) {
      return '-'
   }
   return format(new Date(date.value), FORMATS.filterDateUI)
}

const formatLocaleDate = (
   dateString: string | Date,
   locale: string = 'en-GB'
) => {
   const dateOptions: any = { day: 'numeric', month: 'short', year: 'numeric' }
   if (
      new Date(dateString).toLocaleDateString(locale, dateOptions) ===
      'Invalid Date'
   ) {
      return null
   } else {
      return new Date(dateString).toLocaleDateString(locale, dateOptions)
   }
}

const formatDateForDisplay = (d: string | Date) => {
   const dateOptions: any = { day: 'numeric', month: 'short', year: 'numeric' }
   const formattedDate = new Date(d).toLocaleDateString('en-GB', dateOptions)
   return formattedDate
}

const removeMinYear = (value: string, minYear: number = 1970) => {
   const parts = value.split(' ')
   const yearInt = parseInt(parts[parts.length - 1])
   if (yearInt <= minYear || yearInt === 2099) {
      return '-'
   }
   return value
}

const parseDate = (d?: Date | string) => {
   if (!d) {
      return null
   }

   // If it's already a Date object, return it directly
   if (d instanceof Date) {
      return d
   }

   // If it's a string, parse it directly
   // This avoids double timezone conversions
   return new Date(d)
}

const formatDateForTable = (rawDate?: string) => {
   return !rawDate || rawDate === '' || isNaN(parseInt(rawDate))
      ? '-'
      : removeMinYear(formatDateForDisplay(rawDate))
}

const formatFilterDateForAPI = (date: Date) =>
   format(date, FORMATS.filterDateAPI)

const formatFilterDateForTag = (date: Date) =>
   format(date, FORMATS.filterDateUI)

const formatExcelFileNameDate = (d: string | Date) => {
   const parsedDate =
      typeof d === 'string' ? parse(d, 'd MMM yyyy', new Date()) : d
   return format(parsedDate, FORMATS.excelExport)
}

export {
   FORMATS,
   renderDateOrNothing,
   formatLocaleDate,
   parseDate,
   removeMinYear,
   formatDateForTable,
   formatFilterDateForAPI,
   formatFilterDateForTag,
   formatExcelFileNameDate,
   formatDateForDisplay,
}
